export enum UserRoleEnum {
	Admin = 'ADMIN',
	SiteManager = 'SITE_MANAGEMENT',
	Support = 'MYGOOGLE_SUPPORT',
	Teammate = 'TEAMMATE',
	Communicator = 'COMMUNICATOR'
}
